import {
  SET_IS_PREVIEW,
  SET_ACTIVE_SECTION,
} from './ConsumerActions';

const initialState = {
  activeSection: null,
  isPreview: false,
};

const ConsumerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_PREVIEW:
      return {
        ...state,
        isPreview: true,
      };
    case SET_ACTIVE_SECTION:
      return {
        ...state,
        activeSection: action.activeSection,
      };
    default:
      return state;
  }
};

export default ConsumerReducer;
